import styles from './index.less';
import ScheduleYourFreeDemo from 'src/components/POSWebsite/ScheduleYourFreeDemo';
export default function DemoFormForGoogleAds({ onClose }) {
  return (
    <div className={styles.popupdemoform}>
      <ScheduleYourFreeDemo showOnModal={true} onCloseWhenshowOnModal={onClose} triggerSource={'popup'} />
    </div>
  );
}
